import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useNavigate, useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditStatusComponent = loadable(
  () => import("../../components/Status/EditStatus")
);
const EditStatus = () => {
  const { id } = useParams()
  const navigate = useNavigate();

  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {},
  });
  //Get Handle LAzy Screen
  const { refetch } = useGetHook({
    queryKey: [`status-${id}`],
    url: `${APIS.STATUS}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`status-${id}`, "status"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.STATUS}${id}/`;
    let formData = {
      ...values,
      next_status: values?.next_status?.map((item: any) => (item.id))
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        await refetch()
        navigate("/status-settings");
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Status</span>
      </div>
      <EditStatusComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        handleLazyFetch={refetch}
        statusList={statusList}
      />
    </>
  );
};
export default EditStatus;
